import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Button } from '@keethealth/keet-ui';
import Answers from 'scenes/Questionnaire/components/Answers';

class ObservationSummary extends Component {
  static defaultProps = {
    questionnaireId: '',
    nextActivityId: '',
  }

  static propTypes = {
    questionnaireId: PropTypes.string,
    onSetQuestion: PropTypes.func.isRequired,
    handleMarkAsComplete: PropTypes.func.isRequired,
    nextActivityId: PropTypes.string,
    questionsObject: PropTypes.objectOf(PropTypes.shape({
      index: PropTypes.number,
      readOnly: PropTypes.bool,
      repeats: PropTypes.bool,
      text: PropTypes.string,
      definition: PropTypes.string,
      type: PropTypes.oneOf(['integer', 'string', 'text', 'choice', 'display', 'height', 'number']),
      option: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        valueType: PropTypes.string,
      })),
      answer: PropTypes.oneOfType([
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          valueType: PropTypes.string,
        }),
        PropTypes.arrayOf(PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          type: PropTypes.string,
        })),
      ]),
    })).isRequired,
  }

  state = {
    isSubmitDisabled: false,
  }

  handleSubmit = () => {
    this.setState({ isSubmitDisabled: true });
    this.props.handleMarkAsComplete();
  }

  renderAnswers = () => {
    const { questionsObject, onSetQuestion } = this.props;
    const questionAnswers = [];
    _.forEach(questionsObject, (question) => {
      if (question.answer || question.answer === '') {
        const answerProps = {
          key: question.linkId,
          onSetQuestion,
          questionIndex: question.index,
          text: question.text,
          answer: question.answer,
          repeats: question.repeats,
          option: question.option,
          isAnswerType: true,
          onComplete: () => {},
          onAnswer: () => {},
          disabled: true,
        };

        switch (question.type) {
          case 'choice':
            questionAnswers.push(
              <Answers.Choice {...answerProps} />,
            );
            break;
          case 'integer':
            questionAnswers.push(
              <Answers.Slider {...answerProps} />,
            );
            break;
          case 'string':
          case 'height':
          case 'number':
          case 'text':
            questionAnswers.push(
              <Answers.Text {...answerProps} />,
            );
            break;
          case 'date':
            questionAnswers.push(
              <Answers.Date {...answerProps} />,
            );
            break;
          default:
            break;
        }
      }
    });
    return questionAnswers;
  }

  render() {
    const { isSubmitDisabled } = this.state;
    return (
      <div id="form-summary" className="flex-auto w-100">
        {this.renderAnswers()}
        <Button
          className="center ma3"
          onClick={this.handleSubmit}
          disabled={isSubmitDisabled}
        >
          SUBMIT
          <i className="fas fa-paper-plane ml2" />
        </Button>
      </div>
    );
  }
}

export default ObservationSummary;
